export * from './app-breadcrumbs.component';



// WEBPACK FOOTER //
// /var/www/portaldev/bullseye/src/app/components/app-breadcrumbs/index.ts